export const TracingComponent = {
    name: "gridserver-core",
    version: "2.0"
};

export const enum TracingOperation {
    StartSession = "StartSession",
    ResumeSession = "ResumeSession",
    PostSession = "PostSession",
    PutSession = "PutSession",
    DeleteSession = "DeleteSession",
    GetSession = "GetSession",
    GetSessionList = "GetSessionList",
    AdUpdate = "AdUpdateRequest"
}
